import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpCommonService } from '../../../../../shared/services/http-common.service';
import { Observable } from 'rxjs';
import { GenericHttpResponse } from '../../../../../shared/services/interfaces/generic-http-response.interface';
import { Direccion, DireccionPayload } from './direcciones.interface';

@Injectable({
  providedIn: 'root'
})
export class DireccionesService {
  private http = inject(HttpClient);
  private httpCommonService = inject(HttpCommonService);

  index(params?: { direccion?: string }): Observable<GenericHttpResponse<Direccion[]>> {
    const url = this.httpCommonService.makeUrl('/ubic/direcciones', params);
    return this.http.get<GenericHttpResponse<Direccion[]>>(url);
  }

  show(id: number): Observable<GenericHttpResponse<Direccion>> {
    const url = this.httpCommonService.makeUrl(`/ubic/direcciones/${id}`);
    return this.http.get<GenericHttpResponse<Direccion>>(url);
  }

  store(body: DireccionPayload): Observable<GenericHttpResponse<Direccion>> {
    const url = this.httpCommonService.makeUrl('/ubic/direcciones');
    return this.http.post<GenericHttpResponse<Direccion>>(url, body);
  }

  update(id: number, body: Partial<DireccionPayload>): Observable<GenericHttpResponse<Direccion>> {
    const url = this.httpCommonService.makeUrl(`/ubic/direcciones/${id}`);
    return this.http.put<GenericHttpResponse<Direccion>>(url, body);
  }

  destroy(id: number): Observable<GenericHttpResponse<void>> {
    const url = this.httpCommonService.makeUrl(`/ubic/direcciones/${id}`);
    return this.http.delete<GenericHttpResponse<void>>(url);
  }
}
